/* Current Nostalgia - liquid light shaders (v1.13, v1.15), used by assets/cn-liquid.js. Kept apart so each
   file stays small enough to edit through the Admin API. Load this one first. No backslash escapes. */
(function () {
 var NL = String.fromCharCode(10);
 window.__cnLiquidGL = {
  VS: [
   'precision highp float;',
   'attribute vec2 aPosition;',
   'varying vec2 vUv; varying vec2 vL; varying vec2 vR; varying vec2 vT; varying vec2 vB;',
   'uniform vec2 texelSize;',
   'void main () {',
   'vUv = aPosition * 0.5 + 0.5;',
   'vL = vUv - vec2(texelSize.x, 0.0); vR = vUv + vec2(texelSize.x, 0.0);',
   'vT = vUv + vec2(0.0, texelSize.y); vB = vUv - vec2(0.0, texelSize.y);',
   'gl_Position = vec4(aPosition, 0.0, 1.0);',
   '}'].join(NL),
  HEAD: 'precision highp float; varying vec2 vUv; varying vec2 vL; varying vec2 vR; varying vec2 vT; varying vec2 vB;' + NL,
  FS: {
   clear: 'uniform sampler2D uTexture; uniform float value;' + NL +
    'void main () { gl_FragColor = value * texture2D(uTexture, vUv); }',
   splat: 'uniform sampler2D uTarget; uniform float aspectRatio; uniform vec3 color; uniform vec2 point; uniform float radius;' + NL +
    'void main () { vec2 p = vUv - point; p.x *= aspectRatio; vec3 s = exp(-dot(p, p) / radius) * color;' + NL +
    'gl_FragColor = vec4(texture2D(uTarget, vUv).xyz + s, 1.0); }',
   advect: 'uniform sampler2D uVelocity; uniform sampler2D uSource; uniform vec2 texelSize; uniform vec2 dyeTexelSize; uniform float dt; uniform float dissipation;' + NL +
    'vec4 bilerp (sampler2D sam, vec2 uv, vec2 ts) { vec2 st = uv / ts - 0.5; vec2 i = floor(st); vec2 f = fract(st);' + NL +
    'vec4 a = texture2D(sam, (i + vec2(0.5, 0.5)) * ts); vec4 b = texture2D(sam, (i + vec2(1.5, 0.5)) * ts);' + NL +
    'vec4 c = texture2D(sam, (i + vec2(0.5, 1.5)) * ts); vec4 d = texture2D(sam, (i + vec2(1.5, 1.5)) * ts);' + NL +
    'return mix(mix(a, b, f.x), mix(c, d, f.x), f.y); }' + NL +
    'void main () {' + NL +
    '#ifdef MANUAL_FILTERING' + NL +
    'vec2 coord = vUv - dt * bilerp(uVelocity, vUv, texelSize).xy * texelSize; vec4 result = bilerp(uSource, coord, dyeTexelSize);' + NL +
    '#else' + NL +
    'vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize; vec4 result = texture2D(uSource, coord);' + NL +
    '#endif' + NL +
    'gl_FragColor = result / (1.0 + dissipation * dt); }',
   divergence: 'uniform sampler2D uVelocity;' + NL +
    'void main () { float L = texture2D(uVelocity, vL).x; float R = texture2D(uVelocity, vR).x;' + NL +
    'float T = texture2D(uVelocity, vT).y; float B = texture2D(uVelocity, vB).y; vec2 C = texture2D(uVelocity, vUv).xy;' + NL +
    'if (vL.x < 0.0) { L = -C.x; } if (vR.x > 1.0) { R = -C.x; } if (vT.y > 1.0) { T = -C.y; } if (vB.y < 0.0) { B = -C.y; }' + NL +
    'gl_FragColor = vec4(0.5 * (R - L + T - B), 0.0, 0.0, 1.0); }',
   curl: 'uniform sampler2D uVelocity;' + NL +
    'void main () { float L = texture2D(uVelocity, vL).y; float R = texture2D(uVelocity, vR).y;' + NL +
    'float T = texture2D(uVelocity, vT).x; float B = texture2D(uVelocity, vB).x;' + NL +
    'gl_FragColor = vec4(0.5 * (R - L - T + B), 0.0, 0.0, 1.0); }',
   vorticity: 'uniform sampler2D uVelocity; uniform sampler2D uCurl; uniform float curl; uniform float dt;' + NL +
    'void main () { float L = texture2D(uCurl, vL).x; float R = texture2D(uCurl, vR).x; float T = texture2D(uCurl, vT).x;' + NL +
    'float B = texture2D(uCurl, vB).x; float C = texture2D(uCurl, vUv).x;' + NL +
    'vec2 force = 0.5 * vec2(abs(T) - abs(B), abs(R) - abs(L)); force /= length(force) + 0.0001; force *= curl * C; force.y *= -1.0;' + NL +
    'vec2 v = texture2D(uVelocity, vUv).xy + force * dt; v = min(max(v, -1000.0), 1000.0);' + NL +
    'gl_FragColor = vec4(v, 0.0, 1.0); }',
   pressure: 'uniform sampler2D uPressure; uniform sampler2D uDivergence;' + NL +
    'void main () { float L = texture2D(uPressure, vL).x; float R = texture2D(uPressure, vR).x;' + NL +
    'float T = texture2D(uPressure, vT).x; float B = texture2D(uPressure, vB).x;' + NL +
    'gl_FragColor = vec4((L + R + B + T - texture2D(uDivergence, vUv).x) * 0.25, 0.0, 0.0, 1.0); }',
   gradient: 'uniform sampler2D uPressure; uniform sampler2D uVelocity;' + NL +
    'void main () { float L = texture2D(uPressure, vL).x; float R = texture2D(uPressure, vR).x;' + NL +
    'float T = texture2D(uPressure, vT).x; float B = texture2D(uPressure, vB).x;' + NL +
    'vec2 v = texture2D(uVelocity, vUv).xy - vec2(R - L, T - B); gl_FragColor = vec4(v, 0.0, 1.0); }',
   /* generated liquid: the colour field, lightly shaded for depth, softly toned, over a deep violet ground */
   display: 'uniform sampler2D uTexture; uniform vec2 texelSize; uniform vec3 base;' + NL +
    'void main () { vec3 c = texture2D(uTexture, vUv).rgb;' + NL +
    'float dx = length(texture2D(uTexture, vR).rgb) - length(texture2D(uTexture, vL).rgb);' + NL +
    'float dy = length(texture2D(uTexture, vT).rgb) - length(texture2D(uTexture, vB).rgb);' + NL +
    'vec3 n = normalize(vec3(dx, dy, length(texelSize)));' + NL +
    'c *= clamp(n.z + 0.7, 0.7, 1.0);' + NL +
    'c = (1.0 - exp(-c * 2.4)) * 0.94;' + NL +
    'gl_FragColor = vec4(base + c * (1.0 - base), 1.0); }',
   /* footage: the field holds how far the liquid has carried each spot of the picture; this adds
      the flow to it (k = time step x texel size) */
   push: 'uniform sampler2D uTarget; uniform sampler2D uVelocity; uniform vec2 k;' + NL +
    'void main () { gl_FragColor = vec4(texture2D(uTarget, vUv).xy + texture2D(uVelocity, vUv).xy * k, 0.0, 1.0); }',
   /* footage: the video, cropped to fill the box, drawn through that field, so it flows where it was
      stirred and eases back. v1.15: slowed down, each frame blends into the next (uPrev to uVideo
      by mixF) so it does not stutter.
      clear: the dark parts turn see-through and only the lit liquid stays.
      crt: an old-TV screen - colour fringing, scanlines, flickering static, a slow rolling band and
      darker corners. Output is premultiplied alpha. */
   video: 'uniform sampler2D uTexture; uniform sampler2D uVideo; uniform sampler2D uPrev; uniform vec2 cover;' + NL +
    'uniform float mixF; uniform float time; uniform float clear; uniform float crt;' + NL +
    'float hash (vec2 p) { return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453); }' + NL +
    'vec3 pick (vec2 q) { return mix(texture2D(uPrev, q).rgb, texture2D(uVideo, q).rgb, mixF); }' + NL +
    'void main () { vec2 d = clamp(texture2D(uTexture, vUv).xy, -0.15, 0.15);' + NL +
    'vec2 q = (vUv - d - 0.5) * cover + 0.5; vec3 c;' + NL +
    'if (crt > 0.5) { vec2 f = vec2(0.0024, 0.0); c = vec3(pick(q + f).r, pick(q).g, pick(q - f).b); } else { c = pick(q); }' + NL +
    'c *= 1.0 + 1.2 * length(d);' + NL +
    'float a = 1.0; if (clear > 0.5) { a = smoothstep(0.03, 0.42, dot(c, vec3(0.299, 0.587, 0.114))) * 0.92; }' + NL +
    'vec3 o = c * a;' + NL +
    'if (crt > 0.5) {' + NL +
    'float dk = (0.5 - 0.5 * sin(gl_FragCoord.y * 2.0944)) * 0.34; o *= 1.0 - dk; a = dk + (1.0 - dk) * a;' + NL +
    'float n = hash(floor(gl_FragCoord.xy * 0.5) + fract(time * 7.31) * vec2(91.7, 47.3));' + NL +
    'float g = n * n * n * 0.2 + exp(-pow((fract(vUv.y * 0.6 - time * 0.05) - 0.5) * 7.0, 2.0)) * 0.05;' + NL +
    'o += vec3(0.9, 0.85, 1.0) * g; a += g * (1.0 - a);' + NL +
    'float v = smoothstep(0.35, 0.85, length((vUv - 0.5) * vec2(1.1, 1.0))) * 0.55; o *= 1.0 - v; a = v + (1.0 - v) * a;' + NL +
    'o *= 0.96 + 0.04 * sin(time * 47.0); }' + NL +
    'gl_FragColor = vec4(o, a); }'
  }
 };
})();